import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { NgArrayPipesModule } from 'ngx-pipes';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { NgStyle, NgClass } from '@angular/common';

@Component({
  selector: 'filials',
  templateUrl: './filials.component.html',
  standalone: true,
  imports: [
    NgStyle,
    NgClass,
    SpanTooltipComponent,
    NgArrayPipesModule
  ]
})
export class FilialsComponent implements OnInit {
  skin: string = this.globalCfg.skin;
  nextLevel: number = 1;
  paddingLevel: string = '20px';
  constructor(private globalCfg: GlobalCfgFactory){ }

  @Input() child : any;
  @Input() level : number = 0;
  @Output() openChildEmit = new EventEmitter();
  @Output() selectChildEmit = new EventEmitter();

  ngOnInit(): void {
    this.nextLevel += this.level;
    this.paddingLevel = (16 * this.level) + 20 + 'px';
  }

  openChildren(e: any, child:any){
    let item:any = {
      child: child,
      e: e
    }
    this.openChildEmit.emit(item);
  }

  selectChild(e: any, child:any){
    let item:any = {
      child: child,
      e: e
    }
    this.selectChildEmit.emit(item);
  }

  openChildOn(e:any){
    this.openChildEmit.emit(e);
  }

  selectChildOn(event:any){
    event.e.stopPropagation();
    this.selectChildEmit.emit(event);
  }
}
